// Strips the legacy "(Comprada)" suffix that the marketplace backend
// appends to play names on purchase. Replace with a localized badge.
// `purchased_from` is set on the buyer's copy when the play was purchased.

export function isPurchasedPlay(play) {
  return !!play?.purchased_from;
}

export function stripPurchasedSuffix(name) {
  if (!name) return name;
  return String(name).replace(/\s*\(Comprada\)\s*$/i, '');
}

/** Returns { displayName, purchased } */
export function displayPlayName(play) {
  if (!play) return { displayName: '', purchased: false };
  const purchased = isPurchasedPlay(play);
  return {
    displayName: purchased ? stripPurchasedSuffix(play.name) : (play.name || ''),
    purchased,
  };
}
